import { createAction, PrepareAction } from "@logicsoftware/redux-toolkit";
// eslint-disable-next-line @logicsoftware/ep-custom/no-cross-feature-imports
import type { Portfolio } from "~/Details/portfolioDetails";
import { DeleteEntityPayload, UpdateFieldPayload } from "~/Redux/Middleware/InlineEditMiddleware";

/**
 * This actions is dispatched whenever new portfolio was created.
 */
export const portfolioWasCreated = createAction("PORTFOLIOS/WAS_CREATED", (parentId: number) => ({
    payload: { parentId },
}));

/**
 * This action is dispatched whenever portfolio was deleted.
 */
export const portfolioWasDeleted = createAction("PORTFOLIOS/WAS_DELETED");

/**
 * This action is dispatched whenever portfolio was updated.
 */
export const portfolioWasUpdated = createAction<UpdateFieldPayload<Portfolio>>("PORTFOLIOS/WAS_UPDATED");

/**
 * Action that starts portfolio deletion.
 * It handled by portfolioInlineEdit saga that internally deletes portfolio from
 * store and send corresponding request to the server
 */
export const deletePortfolio = createAction<PrepareAction<DeleteEntityPayload>>("DELETE_PORTFOLIO", (id: number) => ({
    payload: { id },
}));

/**
 * Action that starts portfolio field update.
 * It handled by portfolioInlineEdit saga that internally updates portfolio in store
 * and send corresponding request to the server
 */
export const updatePortfolioField = createAction(
    "UPDATE_PORTFOLIO_FIELD",
    (payload: UpdateFieldPayload<Portfolio>) => ({ payload })
);
